import type { MouseEventHandler, ReactNode } from 'react';
import { LINK_TEXT_CLASS } from '@/components/base/shared-classes';
import type { EffectKey } from '@/mocks/endpoint-map';

export interface LinkProps {
  uiId: string;
  href: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  /**
   * 同 `Button` 的 `dataEffect`（FUNCTIONAL-CONTRACT.md:83-86 D-1）。
   * 只有 onClick 真的會呼叫 `useDataSource()` 方法的連結才可以傳（criteria C5-j）。
   */
  dataEffect?: EffectKey;
  children: ReactNode;
}

/**
 * 純視覺連結。
 *
 * 刻意「不」import react-router-dom：第一層不得知道任何 route（§9.1）。需要 SPA 導覽的地方
 * 由第二／四層包一層 router 的 Link，或直接把 onClick 傳進來。
 *
 * ponytail: 沒有 target／rel／external 圖示等 prop。原系統的外連只有極少數幾處，
 * 到時候由呼叫端自己寫 `<a>` 或再開一個 ExternalLink，不在這裡先養一堆 boolean。
 *
 * onClick 用原生 handler 簽章（同 Button 的理由）：原系統大量使用 `<a href="#" onclick="...">`，
 * 那種用法需要 event.preventDefault()，簽章寫成 `() => void` 會直接卡死。
 */
export function Link({ uiId, href, onClick, dataEffect, children }: LinkProps) {
  return (
    <a
      data-ui-id={uiId}
      data-effect={dataEffect}
      href={href}
      className={LINK_TEXT_CLASS}
      onClick={onClick}
    >
      {children}
    </a>
  );
}
